// create a function that 

export function fetchQueryByCategory(type, queries) {
    let ui_categories_pattern = {
        CURRENT: '',
        PAST: '',
        RECENT: ''
    };
    if (type == "BIZMODEL") {
        ui_categories_pattern = {
            CURRENT: 'Current Business Model',
            PAST: 'Past Business Model',
            RECENT: 'Recent Business Model'
        }
    }
    let res = {};
    Object.keys(queries).forEach((key)=> {
        let query = queries[key];
        if (query.ui_categories.includes(ui_categories_pattern['CURRENT'])) {
            if (!res['CURRENT']) {
                res['CURRENT'] = [];
            }
            res['CURRENT'].push(key);
            return;
        }
        if (query.ui_categories.includes(ui_categories_pattern['RECENT'])) {
            if (!res['RECENT']) {
                res['RECENT'] = [];
            }
            res['RECENT'].push(key);
        }
        if (query.ui_categories.includes(ui_categories_pattern['PAST'])) {
            if (!res['PAST']) {
                res['PAST'] = [];
            }
            res['PAST'].push(key);
        }
    });
    return res;
}